import { render, staticRenderFns } from "./PtCollapse.vue?vue&type=template&id=857fd6d8"
import script from "./PtCollapse.vue?vue&type=script&lang=js"
export * from "./PtCollapse.vue?vue&type=script&lang=js"
import style0 from "./PtCollapse.vue?vue&type=style&index=0&id=857fd6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports